// extracted by mini-css-extract-plugin
module.exports = {"white-box":"white_box__white-box___1etjP"};